import React, { Component } from 'react';
import styles from './index.css'
import {observer} from 'mobx-react'
import FontAwesome from 'react-fontawesome'

@observer
export default class News extends Component {

    render(){
        return(
            <div className={styles.item + ' ' + styles.news}>
                <div className={styles.topMenuHeading}>ПОТОЧНІ НОВИНИ</div>
                <div className={styles.scrollableNews} id="parent">

                    {this.props.news.newsList.map((item,i)=>{
                       return(
                           <div style={item.type} key={i}>
                               <span className={styles.newsItemDateTime}>{item.date}</span>&nbsp;
                               <span className={styles.newsItemIcon}><FontAwesome name={item.font} /></span>&nbsp;
                               <span className={styles.newsItemContent}>{item.massage}</span>
                           </div>
                       )
                    })}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/shared/components/News/index.js